import Store from './modules/store';
import app from '../../package.json';

const data = {
    env: process.env.NODE_ENV || 'development',
    themeDirectory: '/wp-content/themes/treadright.org/',
    domain: 'treadright.org',
    name: app.name,
    release: app.version,
    colors: {
        blue: `#1887C9`,
        green: `#71B549`,
        darkGreen: `#3D6F48`,
        impactgreen: `#319E66`,
        ttcRed: `#E5314A`,
        meBlue: `#05ABE9`,
        teamBlue: `#0AAAC7`,
        brandBlue: `#222B40`,
        tripsBlue: `#05ABE9`,
        black: `#000`,
        pink: `#DD3322`,
        darkPink: `#E5254A`,
        championPink: `#E81F4B`,
        connectPink: `#E71F4A`,
        red: `#C14B1F`,
        yellow: `#FEC23A`,
        lightgray: `#606060`,
        gray: `#7B7B7B`,
        gold: `#B38B4E`
    },
    breakpoint: -1,
    breakpoints: {
        mobile: {
            selector: 'screen and (min-width: 320px) and (max-width: 500px)',
            match: () => {
                // var from = get('breakpoint');
                set('breakpoint', 0);
                // Settings.$body.trigger('breakpointChanged', [Settings.breakpoint, from]);
            },
            unmatch: () => {
                // Settings.$body.trigger('unmatch:mobile');
            }
        },
        'mobile-large': {
            selector: 'screen and (min-width: 500px) and (max-width: 767px)',
            match: () => {
                // var from = Settings.breakpoint;
                set('breakpoint', 1);
                // Settings.$body.trigger('breakpointChanged', [Settings.breakpoint, from]);
            },
            unmatch: () => {
                // Settings.$body.trigger('unmatch:mobile');
            }
        },
        tablet: {
            selector: 'screen and (min-width: 768px) and (max-width: 959px)',
            match: () => {
                // var from = Settings.breakpoint;
                set('breakpoint', 2);
                // Settings.$body.trigger('breakpointChanged', [Settings.breakpoint, from]);
            }
        },
        desktop: {
            selector: 'screen and (min-width: 960px) and (max-width: 1170px)',
            match: () => {
                // var from = Settings.breakpoint;
                set('breakpoint', 3);
                // Settings.$body.trigger('breakpointChanged', [Settings.breakpoint, from]);
            }
        },
        'desktop-large': {
            selector: 'screen and (min-width: 1170px)',
            match: () => {
                // var from = Settings.breakpoint;
                set('breakpoint', 4);
                // Settings.$body.trigger('breakpointChanged', [Settings.breakpoint, from]);
            }
        }
    }
};

const store = new Store(data);

export const get = key => {
    return store.get(key, store.get('env'));
};

export const set = (key, value) => {
    return store.set(key, value, store.get('env'));
};
